// extracted by mini-css-extract-plugin
var _1 = "599px";
var _2 = "1024px";
var _3 = "767px";
var _4 = "ra-slider";
var _5 = "ra-slider-dots";
var _6 = "ra-slider-horizontal-1-1";
var _7 = "ra-slider-horizontal-4-1";
var _8 = "ra-slider-horizontal-5-1";
var _9 = "ra-slider-horizontal-7-1";
var _a = "ra-slider-horizontal-7-2";
var _b = "ra-slider-horizontal";
var _c = "ra-slider-item";
var _d = "ra-slider-placeholder";
export { _1 as "screenExtraSmallMax", _2 as "screenLarge", _3 as "screenSmallMax", _4 as "sliderCls", _5 as "sliderDotsCls", _6 as "sliderHorizontal11Cls", _7 as "sliderHorizontal41Cls", _8 as "sliderHorizontal51Cls", _9 as "sliderHorizontal71Cls", _a as "sliderHorizontal72Cls", _b as "sliderHorizontalCls", _c as "sliderItemCls", _d as "sliderPlaceholderCls" }
